import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

window.onload = () => {
	//
	// js pour désactiver l'action des liens avec juste une ancre
	//
	document.querySelectorAll('a[href="#"]').forEach((el) => {
		el.addEventListener('click', (event) => {
			event.preventDefault();
		})
	})

	//
	// js pour la réécriture des emails
	//
	document.querySelectorAll('.obfsclk').forEach((el) => {
		el.innerHTML = el.innerHTML.replace(new RegExp('{AT}', 'g'), '@').replace(new RegExp('{DOT}', 'g'), '.');
		el.classList.remove('d-none');
	})

	//
	// js pour afficher/masquer le bouton pour retourner en haut de page
	//
	if(document.querySelector('.scrollto')) {
		var prevScrollpos = window.pageYOffset;

		window.onscroll = function() {
			if(window.outerHeight >= 356) {
				var currentScrollPos = window.pageYOffset;

				let scrollto = document.querySelector('body:not(.show-nav) .scrollto');

				if(scrollto) {
					if(prevScrollpos <= currentScrollPos || currentScrollPos <= 0) {
						scrollto.classList.remove('bottom-4');
					} else {
						scrollto.classList.add('bottom-4');
					}
				}

				prevScrollpos = currentScrollPos;
			}
		}
	}

	//
	// js pour placer le bouton pour retourner en haut de page
	//
	function displayRetour() {
		let scrollTo = document.querySelector('.scrollto');
		if(scrollTo) {
			let marginLeft = document.querySelector('body > div.mx-auto').offsetWidth - scrollTo.offsetWidth.toFixed(0);

			scrollTo.style.marginLeft = marginLeft + 'px';
			scrollTo.classList.remove('opacity-0');
		}
	}

	displayRetour();

	addEventListener('resize', () => {
		displayRetour();
	});

	//
	// js pour ajouter la balise title aux liens qui s'ouvrent dans une nouvelle fenêtre
	//
	document.querySelectorAll('.wysiwyg a:not([href^="tel:"])[target="_blank"]').forEach(function(link) {
		if(!link.hasAttribute('title')) {
			var regex = /^(www|http)/;

			if(regex.test(link.textContent)) {
				link.setAttribute('title', link.textContent + ' [nouvelle fenêtre]');
			} else {
				link.setAttribute('title', link.textContent.charAt(0).toUpperCase() + link.textContent.slice(1) + ' [nouvelle fenêtre]');
			}
		}
	});

	//
	// js pour afficher le gestionnaire de consentement aux cookies et pour modifier le positionnement du focus
	//
	document.querySelectorAll('.complianz > *, a.complianz').forEach((el) => {
		el.addEventListener('click', (event) => {
			event.preventDefault();

			cmplz_set_banner_status('');

			if(document.querySelector('.cmplz-categories-type-view-preferences').classList.contains('cmplz-categories-visible')) {
				document.querySelector('.cmplz-category.cmplz-functional > summary').focus();
			} else {
				document.querySelector('.cmplz-btn.cmplz-accept').focus();
			}
		});
	});

	if(document.querySelector('.cmplz-btn.cmplz-view-preferences')) {
		document.querySelector('.cmplz-btn.cmplz-view-preferences').addEventListener('click', function() {
			setTimeout(function() {
				document.querySelector('.cmplz-category.cmplz-functional > summary').focus();
			}, 100);
		});
	}

	//
	// js pour modifier l'affichage du formulaire présent le gestionnaire de consentement aux cookies
	//
	document.querySelectorAll('#cmplz-cookiebanner-container .cmplz-close svg.fa-times').forEach(function(svg) {
		svg.setAttribute('height', '20');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container .cmplz-category:not(.cmplz-functional) .cmplz-banner-checkbox').forEach(function (banner) {
		banner.classList.add('d-flex', 'form-switch', 'lh-1');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container .cmplz-category:not(.cmplz-functional) .cmplz-banner-checkbox .cmplz-consent-checkbox').forEach(function (checkbox) {
		checkbox.classList.add('cursor-pointer', 'form-check-input', 'ms-0', 'mt-0');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container .cmplz-category:not(.cmplz-functional) .cmplz-banner-checkbox .cmplz-label span.screen-reader-text').forEach(function (span) {
		span.classList.remove('screen-reader-text');
		span.classList.add('visually-hidden');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container .cmplz-category:not(.cmplz-functional) .cmplz-banner-checkbox .cmplz-label').forEach(function (label) {
		label.removeAttribute('tabindex');
	});

	document.querySelectorAll('#cmplz-cookiebanner-container .cmplz-category:not(.cmplz-functional) .cmplz-banner-checkbox').forEach(function (banner) {
		banner.classList.remove('cmplz-banner-checkbox');
	});

	//
	// js pour calculer la taille de la scrollbar
	//
	function getScrollbarWidth() {
		let body = document.querySelector('body');

		let div	= document.createElement('div');

		div.style.overflowY	= 'scroll';
		div.style.width		= '20px';
		div.style.height	= '20px';

		document.body.append(div);

		let scrollWidth	= div.offsetWidth - div.clientWidth;

		div.remove();

		for(let i = body.classList.length - 1; i >= 0; i--) {
			const className = body.classList[i];
			if(className.startsWith('scrollbar-')) {
				body.classList.remove(className);
			}
		}

		if(scrollWidth == 0 || scrollWidth == 12 || scrollWidth == 15 || scrollWidth == 17) {
			body.classList.add('scrollbar-' + scrollWidth);
		}
	}

	getScrollbarWidth();

	addEventListener('resize', () => {
		getScrollbarWidth();
	});

	//
	// js pour augmenter le padding de la balise main lorsque les liens d'évitement sont affichés
	//
	document.querySelector('.skiplinks').addEventListener('focusin', function() {
		document.querySelector('main#contenu').classList.add('active');
	});
	
	document.querySelector('.skiplinks').addEventListener('focusout', function() {
		document.querySelector('main#contenu').classList.remove('active');
	});

	//
	// js pour ouvrir un accordéon lorsqu'un hash correspondant à une fiche horaire publiée est présent dans l'url
	//
	var hash								= window.location.hash;

	if(hash) {
		var horaires						= document.querySelector('#horaires');

		if(horaires) {
			var div							= horaires.querySelector('[id="' + hash.substring(1) +'"]');

			if(div) {
				var parent					= div.closest('.accordion-collapse');

				if(parent) {
					parent.classList.add('show');

					var h2					= parent.previousElementSibling;

					if(h2 && h2.tagName.toLowerCase() === 'h2') {
						var button			= h2.querySelector('button');

						if(button) {
							button.classList.remove('collapsed');
							button.setAttribute('aria-expanded', 'false');

							var header		= document.querySelector('header');
							var position	= div.getBoundingClientRect().top + window.scrollY;

							if(header) {
								position	= position - header.offsetHeight;
							}

							window.scrollTo({
								behavior: 'smooth',
								top: position
							});
						}
					}
				}
			}
		}
	}

	//
	// js pour ouvrir la fenêtre modale au chargement de la page
	//
	if(document.getElementById('modal')) {
		new Modal(document.getElementById('modal')).show();
	}

	//
	// js pour afficher et rendre obligatoire le champ "Autre"
	//
	const autreContainer = document.getElementById('autre-container');

	if(autreContainer) {
		const inputTexte = autreContainer.querySelector('input');
		const radios = document.querySelectorAll('input[name="connaissance"]');

		if(inputTexte && radios.length > 0) {
			radios.forEach(radio => {
				radio.addEventListener('change', () => {
					const autreRadio = document.getElementById('autre');

					if(autreRadio && autreRadio.checked) {
						autreContainer.classList.remove('d-none');
						inputTexte.required = true;
					} else {
						autreContainer.classList.add('d-none');
						inputTexte.required = false;
					}
				});
			});
		}
	}
}